<mat-toolbar  class="header-toolbar">
  <!-- Global Navigation -->


  <div class="header-container">
    <div class="logo-section">
      <div class="logo-title">
         <img src="Images/logo_kbr_old.gif" alt="KBR Logo" class="kbr-logo">
         <img src="Images/hdrphoto_image1.jpg" alt="NMA Logo" class="nma-logo">
        </div>
      <!-- <img src="Images/sitename.png" alt="Site Name - Site Description" class="site-logo"> -->
    </div>
    <div class="siteSpecific">
        
      <div class="user-details">

        <h4 class="user-name">User Id : {{ user.userName || '-' }}</h4>
         <p class="egtl-text"> <span>EGTL</span> : Foundation Settlement Tracking</p>

        <ul class="site-links">
          <li>
            <a target="_blank" href="Help/FSM_User_Guide.doc" download>Help</a>
          </li>
          <li>
            <a href="javascript:void(0)" (click)="logout()">Logout
            </a>
          </li>
        </ul>
      </div>
    </div>



  </div>


</mat-toolbar>


